/** 
hybrid modules functions:
all functions that cannot work on IE browser intended for offline reportin is moved here 
*/

import { TagListConfiguration } from "../../models/tag-list-configuration";

// we don't use fetch polyfill here because features like abort signal
// don't exist in older browser so isn't supported in the polyfill
function fetchWithTimeout(resource, options = {}): Promise<Response> {
    const { timeout = 15000 } = options as any;
    
    const controller = new AbortController();
    const id = setTimeout(() => controller.abort(), timeout);
    const response = window.fetch(resource, {
      ...options,
      signal: controller.signal  
    });

    return response.then(res => {
        clearTimeout(id);
        return res;
    })
}

// service worker
const runAnyNewServiceWorker = () => server.reports.query()
    .filter('reportStatus', 'ready').execute()
    .then(function (reports) {
        if (reports.length === 0) {
            messageWaitingServiceWorker({type: 'SKIP_WAITING'});
        }
    })

const messageWaitingServiceWorker = (message) => {
    return navigator.serviceWorker.ready.then( function(registration) {
        if (registration.waiting) {
            registration.waiting.postMessage(message) // message sent to sw in wait state to take over active older sw
        }
    });
};

const messageActiveServiceWorker = (message) => {
    return navigator.serviceWorker.ready.then( function(registration) {
        if (registration.active) {
            registration.active.postMessage(message);
        }
    });
};

const syncReportsServiceWorker = (syncSignals: string | string[]) => {
    let _syncSignals = [].concat(syncSignals);
    return navigator.serviceWorker.ready.then(function(registration) {
        _syncSignals.forEach(signal => registration.sync.register(signal));
    });
}

var channel = new BroadcastChannel('sw-messages');
// meta 
const serverMetaGet = (vesselId) => server.meta.get(vesselId);
const serverMetaUpdate = (metaData) => server.meta.put(metaData);
// user
const serverUsersGet = (username) => server.users.get(username)
const serverUsersUpdate = (userData) => server.users.update(userData)
const serverUsersQuery = (username?) => server.users.query('username').only(username).execute()
// progress
const serverOfflineProgressGet = () => server.progress.get('count') 
const serverProgressUpdate = (payload) => server.progress.update(payload)
// reports
const serverReportsQuery = () => server.reports.query().all().execute()
const serverReportsQueryByVesselId = (vesselId) => server.reports.query().filter('vesselId', vesselId).execute()
const serverReportsUpdate = (vesselReportData) => server.reports.update(vesselReportData)
const serverReportsPut = (vesselReportData) => server.reports.put(vesselReportData)
const serverReportsGet = (reportKey) => server.reports.get(reportKey)
const serverReportsRemove = (reportKey) => server.reports.remove(reportKey)

const serverEngineReportsGet = (reportKey) => server.engineReports.get(reportKey)

const serverEngineReportsUpdate = (engineReportData) => server.engineReports.update(engineReportData)
const serverEngineReportsQuery = () => server.engineReports.query().all().execute()
const serverEngineReportsQueryByVesselId = (vesselId) => server.engineReports.query().filter('vesselId', vesselId).execute()
const serverEngineReportsRemove = (reportKey) => server.engineReports.remove(reportKey)

// offhire reports
const serverOffhireReportsQuery = () => server.offhireReports.query().all().execute();
const serverOffhireReportsQueryByVesselId = (vesselId) => server.offhireReports.query().filter('vesselId', vesselId).execute();
const serverOffhireReportsUpdate = (vesselReportData) => server.offhireReports.update(vesselReportData);
const serverOffhireReportsPut = (vesselReportData) => server.offhireReports.put(vesselReportData);
const serverOffhireReportsGet = (reportKey) => server.offhireReports.get(reportKey);
const serverOffhireReportsRemove = (reportKey) => server.offhireReports.remove(reportKey);

const serverUsersClear = () => server.users.clear()
const serverMetaClear = () => server.meta.clear()
const serverProgressClear = () => server.progress.clear()
const serverReportsClear = () => server.reports.clear()
const serverEngineReportsClear = () => server.engineReports.clear()
const serverOffhireReportsClear = () => server.offhireReports.clear()

const serverTrackPointsQuery = (fromDate: string, toDate: string) => Promise.resolve(null);  // should remain not implemented by default;
const serverTrackPointsQueryByTagName = (fromDate: string, toDate: string, tagName: string) =>  Promise.resolve(null);  // should remain not implemented by default;
const serverVersionQuery = () => Promise.resolve(undefined);  // should remain not implemented by default;

// Tag configuration
const serverTagConfigurationUpdate = (vesselId: string, tagConfiguration: TagListConfiguration) => null;

// Caches
const openCache = (windowBrowser, cacheName) => windowBrowser.caches.open(cacheName)

const registerListener = (eventName, callback) => {
    return channel.addEventListener(eventName, function(event) {
        callback(event);
    })
}



let hybridService = {
    build: 'hybrid',
    fetchWithTimeout,

    serverMetaGet,
    serverMetaUpdate,

    serverUsersGet,
    serverUsersUpdate,
    serverUsersQuery,

    serverOfflineProgressGet,
    serverProgressUpdate,

    serverReportsQueryByVesselId,
    serverReportsQuery,
    serverReportsUpdate,
    serverReportsPut, // TODO: check if this is the same as update?
    serverReportsGet,
    serverReportsRemove,

    serverEngineReportsGet,
    serverEngineReportsUpdate,
    serverEngineReportsQuery,
    serverEngineReportsQueryByVesselId,
    serverEngineReportsRemove,

    serverOffhireReportsQuery,
    serverOffhireReportsQueryByVesselId,
    serverOffhireReportsUpdate,
    serverOffhireReportsPut,
    serverOffhireReportsGet,
    serverOffhireReportsRemove,

    serverUsersClear,
    serverMetaClear,
    serverProgressClear,
    serverReportsClear,
    serverEngineReportsClear,
    serverOffhireReportsClear,

    serverTrackPointsQuery,
    serverTrackPointsQueryByTagName,
    serverVersionQuery,
    serverTagConfigurationUpdate,

    openCache,

    runAnyNewServiceWorker,
    messageWaitingServiceWorker,
    messageActiveServiceWorker,
    syncReportsServiceWorker,
    channel,
    registerListener,
}
type IHybridService = typeof hybridService;
export {
    hybridService as default,
    IHybridService
}
